import React from 'react';

import PropTypes from 'prop-types';
import { MdKeyboardArrowLeft, MdKeyboardArrowRight } from 'react-icons/md';

// @ts-ignore
const Pagination = ({ currentPage, totalPages, onPageChange }) => {
  const pagesPerWindow = 5;
  const currentWindow = Math.ceil(currentPage / pagesPerWindow);

  const startPage = (currentWindow - 1) * pagesPerWindow + 1;
  let endPage = startPage + pagesPerWindow - 1;

  if (endPage > totalPages) {
    endPage = totalPages;
  }

  const pageNumbers = Array.from(
    { length: endPage - startPage + 1 },
    (_, index) => startPage + index
  );

  return (
    <div className="flex flex-col items-center p-5">
      <div className="flex items-center justify-center mt-2 xs:mt-0 space-x-3   w-[50vw] h-[4rem]">
        <button
          disabled={currentPage === 1}
          onClick={() => onPageChange(currentPage - 1)}
          className="flex items-center justify-center px-3 h-8 text-sm font-light text-neutral-800 border-0 rounded-md "
        >
          <MdKeyboardArrowLeft size={20} />
        </button>
        {pageNumbers.map((pageNumber) => (
          <button
            key={pageNumber}
            onClick={() => onPageChange(pageNumber)}
            className={`flex items-center justify-center px-3 h-8 text-sm font-light rounded-md ${
              currentPage === pageNumber
                ? 'bg-primary text-white px-4 !text-base !font-bold !h-9 relative top-[1px]'
                : 'text-neutral-800 bg-neutral-100/70 hover:bg-neutral-200/70 border-[1px] !border-neutral-200/70'
            }`}
          >
            {pageNumber}
          </button>
        ))}
        <button
          onClick={() => onPageChange(currentPage + 1)}
          disabled={currentPage === totalPages}
          className="flex items-center justify-center px-3 h-8 text-sm font-light text-neutral-700 border-0 rounded-md "
        >
          <MdKeyboardArrowRight size={22} />
        </button>
      </div>
    </div>
  );
};

Pagination.propTypes = {
  currentPage: PropTypes.number.isRequired,
  totalPages: PropTypes.number.isRequired,
  onPageChange: PropTypes.func.isRequired,
};

export default Pagination;
